import Modal from 'components/modal/Modal';
import styles from './minigame-icon.style';
import { useState } from 'react';
import { motion } from "framer-motion";
import txcbSocket from "socket/txcb";
import classNames from 'classnames';
import MiniRH from './rongho/miniRH';
import rhSocket from 'socket/rongho-socket';
import BaucuaMiniGame from './baucua/baucua';
import bcSocket from 'socket/baucua-socket';
import XocDiaMiniGame from './xocdia/xocdia';
import xdSocket from 'socket/xocdia-socket';
import TXCB from './txcb/txcb';
import { RootState, useAppSelector } from 'cache/store';
import toast from 'react-hot-toast';
import { tryImg } from 'utils/safeImage';

// import toast from 'react-hot-toast';

interface GameItem {
    id: string;
    source: any;
    isReady: boolean;
    gameType: string;
}

const miniGameList: GameItem[] = [
    {
        id: 'mntxcb',
        source: 'icongame-taixiu',
        isReady: true,
        gameType: 'SICBO',
    },
    {
        id: 'xd',
        source: 'iconXocdia',
        isReady: true,
        gameType: 'XOCDIA',
    },
    {
        id: 'bc',
        source: 'iconBaucua',
        isReady: true,
        gameType: 'BAUCUA',
    },
    {
        id: 'rh',
        source: 'iconMinigame',
        isReady: true,
        gameType: 'RH',
    },
];
export default function MiniGameIcon() {

    const [showGameList, setShowGameList] = useState(false);
    const [showGameTXCB, setShowGameTXCB] = useState(false);
    const [showGameRH, setShowGameRH] = useState(false);
    const [showGameBC, setShowGameBC] = useState(false);
    const [showGameXD, setShowGameXD] = useState(false);
    const [showMsg, setShowMsg] = useState(false);
    const [message, setMessage] = useState("");
    const { isLogged, userInfo } = useAppSelector((state: RootState) => state.auth);
    const openGame = (id: string, typeGame: string, isReady: boolean) => {
        if (!userInfo || !isLogged) {
            toast.error('Vui lòng đăng nhập!');
            return;
        }
    
        const connectIfNeeded = (socket: any, setShowGame: (v: boolean) => void) => {
            setShowGame(true);
            socket.connect(); // Giờ socket.connect() đã tự kiểm tra trạng thái
        };
    
        switch (id) {
            case 'mntxcb':
                connectIfNeeded(txcbSocket, setShowGameTXCB);
                break;
            case 'rh':
                connectIfNeeded(rhSocket, setShowGameRH);
                break;
            case 'bc':
                connectIfNeeded(bcSocket, setShowGameBC);
                break;
            case 'xd':
                connectIfNeeded(xdSocket, setShowGameXD);
                break;
            default:
                console.warn(`Không tìm thấy game id: ${id}`);
                return;
        }
    
        if (isReady) {
            setShowGameList(false);
        }
    };

    const openGameList = () => {
        setShowGameList(true);
    };

    const handleChangeMsg = (inputData: string) => {
        setShowMsg(true);
        setMessage(inputData);
        setTimeout(() => {
            setShowMsg(false);
            setMessage('');
        }, 1500);
    };

    const setGame = (type: string) => {
        if (type === 'txcb') {
            txcbSocket.disconnect();
            setShowGameTXCB(false);
        } else if (type === 'rh') {
            rhSocket.disconnect();
            setShowGameRH(false);
        } else if (type === 'bc') {
            bcSocket.disconnect();
            setShowGameBC(false);
        } else if (type === 'xd') {
            xdSocket.disconnect();
            setShowGameXD(false);
        }
    };

    return (
        <>
            <div className={`${styles.wrapIcon} ${showGameTXCB || showGameRH || showGameBC || showGameXD  ? 'active' : ''}`}>
                <div className={styles.iconItem} onClick={openGameList}>
                    <img src={require(`assets/images/minigame/icon-minigame.png`)} alt="" />
                    <img className='iconItem-txt' src={require(`assets/images/minigame/text-minigame.png`)} alt="" />
                </div>
            </div>
            <div className={`${styles.wrapGameList} ${showGameList ? 'show' : ''}`}>
                <div className={styles.gameInnerList}>
                    {miniGameList.map((game, idx) => (
                        <div className="game-item" key={idx}>
                            <img className={classNames(game.id)} onClick={() => openGame(game.id, game.gameType, game.isReady)} key={game.id} src={tryImg(() => require(`assets/images/minigame/${game.source}.png`))} alt="" />
                        </div>
                    ))}
                </div>
            </div>

            <div className={`${styles.bgOverlay} ${showGameList ? 'active' : ''}`} onClick={() => setShowGameList(false)} />
            <Modal isShow={showGameTXCB} onClose={() => setGame('txcb')} width='100%'>
                <TXCB onClose={() => setGame('txcb')} onChangeMsg={handleChangeMsg}/>
            </Modal>

            <Modal isShow={showGameRH} onClose={() => setGame('rh')}>
                <MiniRH onClose={() => setGame('rh')} onChangeMsg={handleChangeMsg} />
            </Modal>

            <Modal isShow={showGameBC} onClose={() => setGame('bc')} width='100%'>
                <BaucuaMiniGame onClose={() => setGame('bc')} onChangeMsg={handleChangeMsg} />
            </Modal>

            <Modal isShow={showGameXD} onClose={() => setGame('xd')} width='100%'>
                <XocDiaMiniGame onClose={() => setGame('xd')} onChangeMsg={handleChangeMsg} />
            </Modal>

            {showMsg && <motion.div
                className="alertGame"
                animate={{ y: 100 }}
                transition={{ duration: 0.3 }}
            >
                <span className="line lineTop"></span>
                <span className="line lineBottom"></span>
                {message}
            </motion.div>}

        </>
    );
}
